import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { LoanFacilityData, LoanFacilityHistoryData } from '../account.model';

@Component({
    selector: 'ifb-account-facility-widget',
    templateUrl: './account-facility-widget.component.html',
    styleUrls: ['./account-facility-widget.component.scss'],
    standalone: false
})
export class AccountFacilityWidgetComponent implements OnChanges {
  @Input() 
  facility: LoanFacilityData;

  @Input()
  isEditAllowed: boolean;

  reversedHistory: LoanFacilityHistoryData[];

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.facility) {
      this.reversedHistory = this.reversedFacilityHistory();
    }
  }

  private reversedFacilityHistory() : LoanFacilityHistoryData[] {
    return this.facility?.history?.slice().reverse() || [];
  }
}
